

import React, { useState, useEffect } from "react";
import {Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HeaderName from "../../../components/Custom/HeaderName";
import Swal from "sweetalert2";
import { deletePODDetails, getPODList } from "../../../redux/Thunk/podThunk";
import {  getAdminDRSList } from "../../../redux/Thunk/drsThunk";
import moment from "moment";
import { EditIcon } from "../../../components/Icons";
import { useSelector } from 'react-redux';
import { roles } from "../../utils/constant";

const PODList = () =>{
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search,setSearch] = useState('');
  const [PODList, setPODList] = useState([])
  // pagination
  const [page, setPage] = useState({
    page:0,
    pageSize:10
  })
const officeId = useSelector((state) => state.auth.officeId);
  useEffect(()=>{
    fetchPOD()
  },[page])

  // get all POD details
  const fetchPOD = async () => {
    setLoader(true)
    dispatch(getAdminDRSList({page: page.page + 1, limit: page.pageSize,search:"",OfficeId: (role === roles?.OfficeAdmin) ? officeId: ""})).then((res) => {
      setPODList(res?.payload?.data)
      setTotalCount(res?.payload?.total)
      setLoader(false)
    })
  };

  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
      // Map the selected IDs to their corresponding rows
      // const selectedRows = selection?.map(selectedId =>
      //   facilityList.find(row => row?._id === selectedId)
      // );
      setSelectedRows(selectedRows);
    }
  };

  // Edit Office details
  const handleClickEditPOD =(details) =>{
    navigate('/dashboard/PODList/newpod', {state:{editDetails:details,  isDisabled: true, }})
  }

  // Deleted POD details
  const handleClickDeletePOD = (row) =>{
      Swal.fire({ 
        title: `Are you sure you want to delete the selected POD ?`,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          return dispatch(deletePODDetails(row?.PodId)).then((res)=>{
            if(res?.payload?.success === true){
              Swal.fire('Deleted!', res?.payload?.message, 'delete');
              fetchPOD()
              setSelectedRows([])
            }else{
              Swal.fire('Error!', res?.payload?.message, 'error');
            }
          });
        },
      });
  }

  const columns = [
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Sr.No',
      align:'center',
      headerName: 'Sr. No',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', padding:1, alignItems: 'center',justifyContent: 'center' }}>
            <Typography noWrap variant='body2' sx={{textAlign:'left',}}>
              {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id)+1}
            </Typography>
          </Box>
        )
      }
    },
    // {
    //   flex: 0.25,
    //   minWidth: 100,
    //   field: 'PodId',
    //   headerName: 'Id',
    //   align:'center',
    //   renderCell: params => {
    //     const { row } = params
  
    //     return (
    //       <Box sx={{ display: 'flex', alignItems: 'left' }}>
    //         <Typography noWrap variant='body2' sx={{textAlign:'left',}}>
    //           {row?.PodId}
    //         </Typography>
    //       </Box>
    //     )
    //   }
    // },
    {
      flex: 0.25,
      minWidth: 150,
      field: 'Docket ID',
      headerName: 'Docket ID',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.DocketId.join(",") || '--'}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: 'Office Name',
      headerName: 'Office Name',
      align:'center',
      renderCell: params => {
        const { row } = params
           const branchName = params.row?.Branch?.OfficeName || '--'
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {branchName||"--"}
            </Typography>
          </Box>
        )
      }
    }, 
    {
        flex: 0.35,
        minWidth: 130,
        field: 'POD Date',
        align:'center',
        headerName: 'Delivery BoyName',
        renderCell: params => {
          const { row } = params
    
          return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
             {row?.DeliveryBoy[0]?.AdminName || '--'}
              </Typography>
            </Box>
          </>
          )
        }
    },
    {
      flex: 0.35,
      minWidth: 120,
      field: 'Delivery Date',
      align:'center',
      headerName: 'Delivery',
      renderCell: params => {
      const { row } = params
        return (<>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
            {moment(row?.DeliveryDate).format('D/M/YYYY')}
          </Typography>
        </Box>
        </>
        )
      }
    },
    // {
    //   flex: 0.55,
    //   minWidth: 220,
    //   field: 'Remark',
    //   align:'center',
    //   headerName: 'Status',
    //   renderCell: params => {
    //     const { row } = params
  
    //     return (
    //     <>
    //       <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //         <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
    //           {row?.PickupDetails?.[0?.] || '--'}
    //         </Typography>
    //       </Box>
    //     </>
    //     )
    //   }
    // },
    {
      flex: 0.55,
      minWidth: 220,
      field: 'Remark',
      align:'center',
      headerName: 'Remark',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.Remark || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Action',
      headerName: 'Action',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2'>
                          <IconButton id='view' onClick={() => handleClickEditPOD(row)}><VisibilityIcon style={{color:'#04AB44'}}/></IconButton>
                
                {/* <IconButton id='edit' onClick={() => handleClickEditPOD(row)}><EditIcon w={18} h={18} /></IconButton>
                <IconButton id='delete' onClick={()=> handleClickDeletePOD(row)}><DeleteIcon fontSize="medium" style={{color:'#04AB44'}}/></IconButton> */}
              </Typography>
            </Box>
          </Box>
        )
      }
    },    
  ]

    return(
        <>
          <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
            {/* <Header /> */}
            { loader ? <PageLoader /> : 
              <Grid container style={{padding:'0px 10px', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>   
                <Grid size={{ xs: 12, sm: 12, md: 12, lg:12 }}>
                  <HeaderName headerName={'POD List'} newForm = {false} onClickBackButton={()=> navigate("/dashboard")} />
                  <div className="custom-data-grid-container_table">
                    <DataGrid
                      sx={{
                        borderRadius: "31px",
                        overflow: "auto",
                      }}
                      style={{ width: '100%' }}
                      pagination
                      // checkboxSelection
                      rows={PODList}
                      rowHeight={55}
                      rowCount={totalCount}
                      getRowId={param=> param._id}
                      columns={columns}
                      paginationModel={page}
                      sortingMode='server'
                      paginationMode='server'
                      pageSizeOptions={[10, 50, 100]}
                      onPaginationModelChange={(newPage)=>setPage(newPage)}
                      className="custom-data-grid"
                      selectionModel={selectedRows ? [selectedRows] : []}
                      onRowSelectionModelChange={handleRowSelection}
                      initialState={{
                        totalCount,
                        pagination: { paginationModel: {page:1, pageSize: 10}},
                      }}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      disableColumnFilter
                      disableColumnSorting
                    />
                  </div>
                </Grid>
              </Grid>
            }
          </div>
        </>
    )
}

export default PODList